/**
 * users模块接口列表
 */
import Vue from "vue";
import axios from '@/utils/http';
import axiosExample from 'axios';
const api = {
  /*
   * 并发axios请求
   * array；[axios1，axios2，axios3，axios4]
   */
  simultaneously(array){
    return axiosExample.all(array);
  },
  //获取当前供应商合同区分
  vendorbuytype() {
    return axios.get(`${Vue.prototype.$base.API_PATH}/common/vendorbuytype`, {
      mask:false
    });
  },
  //获取价格卡列表集合
  pcards() {
    return axios.get(`${Vue.prototype.$base.API_PATH}/common/pcards`, {
      mask:false
    });
  },
  //获取发送形式集合
  deliverys() {
    return axios.get(`${Vue.prototype.$base.API_PATH}/common/deliverys`, {
      mask:false
    });
  },
  //获取标签集合
  tags() {
    return axios.get(`${Vue.prototype.$base.API_PATH}/common/tags`, {
      mask:false
    });
  },
  //获取税率区分集合
  taxs() {
    return axios.get(`${Vue.prototype.$base.API_PATH}/common/taxs`, {
      mask:false
    });
  },
  //获取颜色集合
  colors() {
    return axios.get(`${Vue.prototype.$base.API_PATH}/common/colors`, {
      mask:false
    });
  },
  //获取尺寸
  sizes(dpt) {
    var _params = {
      dpt:dpt
    }
    return axios.get(`${Vue.prototype.$base.API_PATH}/common/sizes`, {
      mask:false,
      params:_params
    });
  },
  //获取材质集合
  fabrics(dpt) {
    var _params = {
      dpt:dpt
    }
    return axios.get(`${Vue.prototype.$base.API_PATH}/common/fabrics`, {
      mask:false,
      params:_params
    });
  },
  //获取式样集合
  patterns(dpt) {
    var _params = {
      dpt:dpt
    }
    return axios.get(`${Vue.prototype.$base.API_PATH}/common/patterns`, {
      mask:false,
      params:_params
    });
  },
  //获取图案集合
  designs(dpt) {
    var _params = {
      dpt:dpt
    }
    return axios.get(`${Vue.prototype.$base.API_PATH}/common/designs`, {
      mask:false,
      params:_params
    });
  },
  //获取品牌集合
  brands(dpt) {
    var _params = {
      dpt:dpt
    }
    return axios.get(`${Vue.prototype.$base.API_PATH}/common/brands`, {
      mask:false,
      params:_params
    });
  },
  //获取其他集合
  styles(dpt) {
    var _params = {
      dpt:dpt
    }
    return axios.get(`${Vue.prototype.$base.API_PATH}/common/styles`, {
      mask:false,
      params:_params
    });
  },
  //获取温度带集合
  temperature() {
    return axios.get(`${Vue.prototype.$base.API_PATH}/common/temperature`, {
      mask:false,
    });
  },
  //检查输入的商品编码是否符合规则
  chkitem1data(_item1) {
    var _params = {
      item1:_item1
    }
    return axios.get(`${Vue.prototype.$base.API_PATH}/common/chkitem1data`, {
      mask:false,
      params:_params
    });
  },
  //检查输入的商品编码针对m表是否存在
  isexistitemm(_item1) {
    var _params = {
      item1:_item1
    }
    return axios.get(`${Vue.prototype.$base.API_PATH}/common/isexistitemm`, {
      mask:false,
      params:_params
    });
  },
  //检查输入的商品编码针对mck表是否存在
  isexistitemck(_item1) {
    var _params = {
      item1:_item1
    }
    return axios.get(`${Vue.prototype.$base.API_PATH}/common/isexistitemck`, {
      mask:false,
      params:_params
    });
  },
  //判断是否可操作qc
  isHandleQc(_item1) {
    var _params = {
      item1:_item1
    }
    return axios.get(`${Vue.prototype.$base.API_PATH}/common/ishandleqc`, {
      mask:false,
      params: _params
    });
  },
  //操作类型集合
  opflgs() {
    return axios.get(`${Vue.prototype.$base.API_PATH}/common/opflgs`, {
      mask:false
    });
  },
  //商品基础信息登录-验证是否存在流程的证照录入
  isexistqc(_item1,_dpt) {
    return axios.get(`${Vue.prototype.$base.API_PATH}/common/isexistqc`, {
      mask:false,
      params: {
        item1:_item1,
        dpt:_dpt
      }
    });
  },
  //操作类型集合
  iteminfo(code) {
    return axios.get(`${Vue.prototype.$base.API_PATH}/common/iteminfo/`+code, {
      mask:false
    });
  },
  //尝试HEAD请求,只是想检查URL是否可访问,尝试发送一个HEAD请求,不支持跨域
  head(url){
    return axios.head(url,{
      mask:false
    });
  },
  //尝试HEAD请求,只是想检查URL是否可访问,尝试发送一个HEAD请求,不支持跨域
  isdptbuyingtypeDPT(dpt){
    return axios.get(`${Vue.prototype.$base.API_PATH}/common/isdptbuyingtype/`+dpt, {
      mask:false
    });
  }
}

export default api;



// WEBPACK FOOTER //
// ./src/api/common.js